var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, formTracking } = options ;
   const is_spec_home = property.search_flags && 
   property.search_flags.is_spec_home ;
   let  thank_you_lead_text =  property.property_type == 'new_plan' || is_spec_home ? "a local builder" : "local real estate professionals";

__p+='\n\n';
 if (!property.suppress_lead_form) { 
__p+='\n  <div id="qv-form" class="leadForm lead-form-primary form-sm qv-lead-form qv-share-form">\n    <div class="share-form-title-wrap"><h3 class="lead-form-title font-semibold no-margin">Thank you for your interest!</h3><p class="font-size-base margin-top">Your message was sent to '+
((__t=(thank_you_lead_text ))==null?'':__t)+
'. Check your email for details.</p></div>\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/forms/qv-sec-share-form.jst.ejs